/* mx-buy-box.js · Ella · Edición Maximus (30-sep-2026)
   Vainilla, sin librerías. El formulario nativo de Ella es el motor; esto solo:
   1) escribe el id de la variante en el formulario nativo al instante (nunca se agrega la variante anterior),
   2) avisa al selector nativo para que Ella actualice precio, galería y barra,
   3) cambia el texto y el precio del botón,
   4) muestra la barra fija en celular cuando el botón principal sale de la pantalla. */
(function () {
  'use strict';
  if (window.__mxBuyBox) return;
  window.__mxBuyBox = true;

  var NATIVE = 'variant-selects[data-context^="main"]';

  function init(root) {
    if (!root || root.__mxInit) return;
    root.__mxInit = true;

    var formId = root.getAttribute('data-form');
    var radios = Array.prototype.slice.call(root.querySelectorAll('.mx-pack__radio'));
    var cta = root.querySelector('[data-mx-cta]');
    var label = root.querySelector('[data-mx-label]');
    var price = root.querySelector('[data-mx-price]');
    var live = root.querySelector('[data-mx-live]');
    var sticky = root.querySelector('[data-mx-sticky]');
    var stickyBtn = root.querySelector('[data-mx-cta-sticky]');
    var stickyLabel = root.querySelector('[data-mx-label-sticky]');
    var stickyName = root.querySelector('[data-mx-sticky-name]');
    var stickyPrice = root.querySelector('[data-mx-sticky-price]');
    var headPrice = root.querySelector('[data-mx-head-price]');
    var headAntes = root.querySelector('[data-mx-head-antes]');
    var headPct = root.querySelector('[data-mx-head-pct]');
    var busyTimer = 0;

    function form() { return document.getElementById(formId); }

    function writeId(id) {
      var f = form();
      var input = f && f.querySelector('input[name="id"]');
      if (input && String(input.value) !== String(id)) input.value = id;
    }

    function nativeRadio(optId) {
      if (!optId) return null;
      return document.querySelector(NATIVE + ' [data-option-value-id="' + optId + '"]');
    }

    function syncNative(radio) {
      writeId(radio.value);
      var nat = nativeRadio(radio.getAttribute('data-option-value-id'));
      if (nat && !nat.checked) {
        nat.checked = true;
        nat.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function paint(radio, announce) {
      radios.forEach(function (r) {
        var tile = r.closest('.mx-pack');
        if (tile) tile.classList.toggle('is-on', r === radio);
      });
      var ok = radio.getAttribute('data-available') !== 'false';
      var lbl = ok ? radio.getAttribute('data-label') : 'Agotado por ahora';
      var prc = ok ? radio.getAttribute('data-price') : '';
      if (label) label.textContent = lbl;
      if (price) price.textContent = prc;
      if (cta) cta.disabled = !ok;
      if (stickyLabel) stickyLabel.textContent = lbl;
      if (stickyPrice) stickyPrice.textContent = prc;
      if (stickyName) stickyName.textContent = radio.getAttribute('data-name') || '';
      if (stickyBtn) stickyBtn.disabled = !ok;
      // Precio junto al título (3-nov-2026): el del paquete elegido, con «Antes» y porcentaje si hay ahorro
      if (headPrice && prc) headPrice.textContent = prc;
      var antes = radio.getAttribute('data-antes') || '';
      var pct = radio.getAttribute('data-pct') || '';
      if (headAntes) { headAntes.hidden = !antes; var t = headAntes.lastChild; if (t && t.nodeType === 3) t.nodeValue = antes; else headAntes.appendChild(document.createTextNode(antes)); }
      if (headPct) { headPct.hidden = !pct; headPct.textContent = pct; }
      if (announce && live) live.textContent = 'Elegiste ' + (radio.getAttribute('data-name') || '') + ', ' + (radio.getAttribute('data-price') || '');
    }

    function selectById(id, announce) {
      var hit = radios.filter(function (r) { return String(r.value) === String(id); })[0];
      if (!hit) return;
      hit.checked = true;
      paint(hit, announce);
    }

    // Elegir un paquete
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        paint(r, true);
        syncNative(r);
      });
    });

    // Antes de enviar: el formulario nativo siempre lleva el paquete que se ve elegido
    function onPress() {
      var checked = radios.filter(function (r) { return r.checked; })[0];
      if (checked) writeId(checked.value);
      [cta, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.setAttribute('aria-busy', 'true');
      });
      window.clearTimeout(busyTimer);
      busyTimer = window.setTimeout(function () {
        [cta, stickyBtn].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
      }, 1600);
    }
    [cta, stickyBtn].forEach(function (b) { if (b) b.addEventListener('click', onPress); });

    // Si Ella cambia la variante por otro camino (enlace con ?variant, atrás/adelante)
    document.addEventListener('variant:update', function (e) {
      var v = e && e.detail && e.detail.resource;
      if (v && v.id) selectById(v.id, false);
    });

    // Alinear el formulario nativo con el paquete preseleccionado al cargar (sin disparar recarga AJAX de galería)
    var first = radios.filter(function (r) { return r.checked; })[0];
    if (first) {
      writeId(first.value);
      window.addEventListener('load', function () { writeId(first.value); }, { once: true });
    }

    // Selector nativo fuera del teclado y de los lectores de pantalla (queda oculto a la vista)
    function hideNative() {
      if (root.getAttribute('data-native-picker') === 'true') return;
      var nat = document.querySelector(NATIVE);
      if (nat) { nat.setAttribute('aria-hidden', 'true'); if ('inert' in nat) nat.inert = true; }
    }
    hideNative();
    document.addEventListener('variant:update', function () { window.setTimeout(hideNative, 80); window.setTimeout(hideNative, 650); });

    // Barra fija: aparece siempre que el botón principal no se vea (debajo de la pantalla o ya pasado)
    if (sticky && root.getAttribute('data-sticky') !== 'false' && 'IntersectionObserver' in window && cta) {
      document.body.appendChild(sticky);
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var seen = e.isIntersecting && e.intersectionRatio >= 0.6;
        sticky.hidden = seen;
        document.documentElement.classList.toggle('mx-sticky-on', !seen);
      }, { threshold: [0, 0.6, 1] });
      io.observe(cta);
    }
  }

  // Estimado de entrega: fecha desde hoy (hora de CDMX); si es fin de semana o pasan las 12:00, cuenta desde el siguiente día hábil.
  function entrega() {
    var els = document.querySelectorAll('[data-mx-entrega]');
    if (!els.length || !window.Intl || !Intl.DateTimeFormat.prototype.formatToParts) return;
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Mexico_City', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    } catch (e) { return; }
    var g = {};
    parts.forEach(function (p) { g[p.type] = parseInt(p.value, 10); });
    if (!g.year || !g.month || !g.day) return;
    var biz = function (x) { var w = x.getDay(); return w !== 0 && w !== 6; };
    var start = new Date(g.year, g.month - 1, g.day);
    if (!biz(start) || g.hour >= 12) { do { start.setDate(start.getDate() + 1); } while (!biz(start)); }
    var add = function (x, n) { var r = new Date(x); while (n > 0) { r.setDate(r.getDate() + 1); if (biz(r)) n--; } return r; };
    var fmt = function (x) { return x.toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); };
    for (var i = 0; i < els.length; i++) {
      var mn = parseInt(els[i].getAttribute('data-min'), 10) || 2, mx = parseInt(els[i].getAttribute('data-max'), 10) || 5;
      els[i].innerHTML = 'Llega entre el <strong>' + fmt(add(start, mn)) + '</strong> y el <strong>' + fmt(add(start, mx)) + '</strong> a todo México (estimado)';
    }
  }

  function boot() {
    entrega();
    var nodes = document.querySelectorAll('[data-mx-bb]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();

/* Visor de fotos en celular: deslizar cambia de foto y mueve la miniatura activa */
(function () {
  function bind(dialog) {
    var list = dialog.querySelector('.dialog-zoomed-gallery');
    var thumbs = dialog.querySelector('.dialog-thumbnails-list');
    if (!list || list.dataset.mxSwipe) return;
    list.dataset.mxSwipe = 'true';
    list.addEventListener('scroll', function () { dialog.handleScroll(); }, { passive: true });
    dialog.addEventListener('zoom-media:selected', function (e) {
      var item = thumbs && thumbs.children[e.detail.index];
      if (item) thumbs.scrollTo({ left: item.offsetLeft - thumbs.clientWidth / 2 + item.offsetWidth / 2, behavior: 'smooth' });
    });
  }
  function boot() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    customElements.whenDefined('zoom-dialog').then(function () {
      document.querySelectorAll('zoom-dialog').forEach(bind);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* WhatsApp flotante: se esconde mientras la persona elige paquete, para no tapar precios */
(function () {
  var packs = document.getElementById('mx-paquetes');
  if (!packs || !('IntersectionObserver' in window) || !window.matchMedia('(max-width: 749px)').matches) return;
  new IntersectionObserver(function (entries) {
    document.documentElement.classList.toggle('mx-wa-off', entries[0].isIntersecting);
  }).observe(packs);
})();
